// extracted by mini-css-extract-plugin
module.exports = {"alertSandbox":"AlertList_alertSandbox__3UpNs"};